/** @jsx jsx */
import { jsx, ThemeProvider, Flex } from 'theme-ui';
import { CookiesProvider } from 'react-cookie';
import GlobalStyle_v1 from '../../gatsby-plugin-theme-ui-v1/GlobalStyle';
import theme_v1 from '../../gatsby-plugin-theme-ui-v1';
import GlobalStyle_v2 from '../../gatsby-plugin-theme-ui/GlobalStyle';
import theme_v2 from '../../gatsby-plugin-theme-ui';
import Footer from '../footer/footer';

/*
- If a page has no regionConfig, it will not render a Header, Footer, noscript Iframe. An example is the index page ("/")

- The bodyGTMIframe is a <noscript> tag with a *text* representation of an <iframe> as the content inside
-- The height="0" width="0" iframe will not visually display, but will make a request to the src, which is used to count users who have JS disabled
-- if the newline breaks of `{regionConfig?.bodyGTMIframe && ` logic are removed, it will not include bodyGTMIframe, effectively breaking it
*/

const Layout = ({ backgroundColor, regionConfig, children }) => {

  // Default to Harry's styles
  var GlobalStyle = GlobalStyle_v2,
  theme = theme_v2;

  if(regionConfig && regionConfig.region !== 'US') {
    GlobalStyle = GlobalStyle_v1;
    theme = theme_v1;
  }

  return (
    <CookiesProvider>
      <GlobalStyle />
      <ThemeProvider theme={theme}>
        <Flex
          sx={{
            backgroundColor,
            flexDirection: 'column',
            fontFamily: 'body',
            minHeight: '100vh',

            h1: theme.styles.root.h1,
            h2: theme.styles.root.h2,
            h3: theme.styles.root.h3,
            h4: theme.styles.root.h4,
            h5: theme.styles.root.h5,
            h6: theme.styles.root.h6,
            h7: theme.styles.root.h7,
            p: theme.styles.root.p
          }}
        >
          <main
            sx={{
              width: '100%',
              flex: '1 1 auto',
            }}
          >
            {children}
          </main>
          {regionConfig?.region && <Footer regionConfig={regionConfig} />}
        </Flex>
      </ThemeProvider>
    </CookiesProvider>
  );
};

export default Layout;
